"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IOSSwitch = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styles_1 = require("@mui/material/styles");
const material_1 = require("@mui/material");
const LeaderboardContext_1 = require("../Context/LeaderboardContext");
const IOSSwitch = (props) => {
    const { factor } = (0, LeaderboardContext_1.useLeaderboardContext)();
    const StyledSwitch = (0, styles_1.styled)(material_1.Switch)(({ theme }) => ({
        width: 38 * factor,
        height: 22 * factor,
        padding: 0,
        '& .MuiSwitch-switchBase': {
            padding: 0,
            margin: 2 * factor,
            transitionDuration: '300ms',
            '&.Mui-checked': {
                transform: `translateX(${16 * factor}px)`,
                color: '#fff',
                '& + .MuiSwitch-track': {
                    backgroundColor: 'primary.main',
                    opacity: 1,
                    border: 0,
                },
                '&.Mui-disabled + .MuiSwitch-track': {
                    opacity: 0.5,
                },
            },
            '&.Mui-focusVisible .MuiSwitch-thumb': {
                color: 'primary.main',
                border: `${6 * factor}px solid #fff`,
            },
            '&.Mui-disabled .MuiSwitch-thumb': {
                color: 'lightgrey'
            },
            '&.Mui-disabled + .MuiSwitch-track': {
                opacity: 0.7,
            },
        },
        '& .MuiSwitch-thumb': {
            boxSizing: 'border-box',
            width: 18 * factor,
            height: 18 * factor,
        },
        '& .MuiSwitch-track': {
            borderRadius: (22 * factor) / 2,
            backgroundColor: 'lightgrey',
            opacity: 1,
            transition: theme.transitions.create(['background-color'], {
                duration: 500,
            }),
            ...theme.applyStyles('dark', {
                backgroundColor: '#39393D',
            }),
        },
    }));
    return (0, jsx_runtime_1.jsx)(StyledSwitch, { ...props });
};
exports.IOSSwitch = IOSSwitch;
